import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step3 = ({ sra, setSra, setStep, storedUser }) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [supplier, setSupplier] = useState();
  const [dataLoading, setDataLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const getSourcingSummary = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft/recommended-summary?draftSraId=${sra.draftSraId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setSupplier(res.data);
      } catch (error) {
        console.log(error);
      } finally {
        setDataLoading(false);
      }
    };
    getSourcingSummary();
  }, []);

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleNext = async () => {
    // if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/draft?draftSraId=${sra.draftSraId}`,
        {
          justification: sra.justification,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    setStep((prev) => prev - 1);
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Sourcing Justification</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "60%" }}></span>
      </div>
      <div className="dashboard-container">
        {dataLoading ? (
          <Box>Loading...</Box>
        ) : (
          <Box>
            <Typography className="form-title">
              Recommended Supplier Details
            </Typography>
            <Typography>
              <span style={{ fontWeight: "bold" }}>Recommended Supplier:</span>{" "}
              {supplier && supplier.name}
            </Typography>
            <Typography>
              <span style={{ fontWeight: "bold" }}>Purchase Performance:</span>{" "}
              {supplier && `${supplier.currency.currency} ${supplier.initialTotal - supplier.finalTotal}`}
            </Typography>
            <Typography>
              <span style={{ fontWeight: "bold" }}>Saving w.r.t LPO:</span>{" "}
              {supplier && `${supplier.currency.currency} ${supplier.lpoTotal - supplier.finalTotal}`}
            </Typography>

            <Typography className="form-title">
              Sourcing Justification
            </Typography>
            <label htmlFor="justification">Recommendation Justification</label>
            <textarea
              className={`${errors.justification && "input-error"}`}
              name="justification"
              id="justification"
              rows={8}
              value={sra && sra.justification}
              onChange={handleChange}
              maxLength={1000}
            ></textarea>
            {errors.justification && (
              <p className="error">{errors.justification}</p>
            )}
          </Box>
        )}
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step3;
